import { EventEmitter, Injectable } from '@angular/core';
import * as P from 'leaflet';
import Marker = P.Marker;
import Icon = P.Icon;
import Polyline = P.Polyline;
import Polygon = P.Polygon;
import Circle = P.Circle;
import FeatureGroup = P.FeatureGroup;
import 'leaflet.markercluster';


@Injectable({
  providedIn: 'root'
})
export class MapService {

  public markers: Marker[] = [];
  public polylines: Polyline[] = [];
  markercluster = P.markerClusterGroup();
  public map: P.Map;
  public baseMaps: any;
  public drawnItems: FeatureGroup;
  public drawControl: P.Control.Draw;
  
  public mapLoaded: EventEmitter<boolean> = new EventEmitter<boolean>();
  public markerWasAdded: EventEmitter<any> = new EventEmitter<any>();
  public markerWasEdited: EventEmitter<any> = new EventEmitter<any>();
  public polygons: Polygon[] = [];
  public circles: Circle[] = [];
  public markersPoi: Marker[] = [];
  public polygonsPoi: Polygon[] = [];
  constructor() {

 

  }

  
  init() {
    this.polygons = [];
    this.markers = [];
    this.polylines = [];
    this.circles = [];
    this.markersPoi = [];
    this.polygonsPoi = [];
}


initCluster() {
    this.markercluster = P.markerClusterGroup({
        disableClusteringAtZoom: 12
    });

}



setView(coordinate: any) {
    this.map.setView(coordinate, 15);
}

addCircle(circle: Circle) {
    this.circles.push(circle);
    circle.addTo(this.map);
}

removeCirclesFromMap() {
    this.circles.forEach(m => {
        this.map.removeLayer(m);
    });
    this.circles = [];
}

addMarker(marker: Marker) {
    this.markers.push(marker);
    marker.addTo(this.map);
}

addMarkerPoi(marker: Marker) {
    this.markersPoi.push(marker);
    marker.addTo(this.map);
}

removeMarkersPoiFromMap() {
    this.markersPoi.forEach(m => {
        this.map.removeLayer(m);
    });
    this.markersPoi = [];
}

removeMarker(index: number) {
    this.map.removeLayer(this.markers[index]);
    delete this.markers[index];
}

addMarkersToMap() {
    this.markers.forEach(marker => {
        marker.addTo(this.map);
    })
}

removeMarkersFromMap() {
    this.markers.forEach(m => {
        this.map.removeLayer(m);
    });
    this.markers = [];
}

addPolyline(polyline: Polyline) {
    this.polylines.push(polyline);
    polyline.addTo(this.map);
}

removePolylinesFromMap() {
    this.polylines.forEach(m => {
        this.map.removeLayer(m);
    });
    this.polylines = [];
}

addPolygon(polygon: Polygon) {
    this.polygons.push(polygon);
    polygon.addTo(this.map);
}

addPolygonPoi(polygon: Polygon) {
    this.polygonsPoi.push(polygon);
    polygon.addTo(this.map);
}


removePolygon(index: number) {
    //this.map.removeLayer(this.polygons[index]);
    delete this.polygons[index];
}

addPolygonsToMap() {
    this.polygons.forEach(Polygon => {
        Polygon.addTo(this.map);
    })
}

removePolygonsFromMap() {
    this.polygons.forEach(m => {
        this.map.removeLayer(m);
    });
    this.polygons = [];
}

removePolygonsPoiFromMap() {
    this.polygonsPoi.forEach(m => {
        this.map.removeLayer(m);
    });
    this.polygonsPoi = [];
}

resetMap() {
    this.removeMarkersFromMap();
    this.removePolygonsFromMap();
    this.removePolylinesFromMap();
}

disableMouseEvent(elementId: string) {
    let element = <HTMLElement>document.getElementById(elementId);
    P.DomEvent.disableClickPropagation(element);
    P.DomEvent.disableScrollPropagation(element);
};

centerMap(arr: any, maxZoom: number) {
    var maxlat = -Infinity,
        minlat = +Infinity,
        maxlng = -Infinity,
        minlng = +Infinity;

    if (arr.length > 0) {
        arr.forEach(rt => {
            if (rt.coordinate.lat != 0 && rt.coordinate.lng != 0) {
                if (maxlat < rt.coordinate.lat) {
                    maxlat = rt.coordinate.lat;
                }
                if (minlat > rt.coordinate.lat) {
                    minlat = rt.coordinate.lat;
                }
                if (maxlng < rt.coordinate.lng) {
                    maxlng = rt.coordinate.lng;
                }
                if (minlng > rt.coordinate.lng) {
                    minlng = rt.coordinate.lng;
                }
            }
        });
        var center1 = new P.LatLng(maxlat, maxlng),
            center2 = new P.LatLng(minlat, minlng);
        var bounds = new P.LatLngBounds(center1, center2);
        this.map.fitBounds(bounds, { padding: [50, 50], maxZoom: maxZoom });
    }
}

offsetMap(arr: any, zoom: number, x: number, y: number) {
    this.map.setZoom(zoom);
    var centerPoint = this.map.latLngToContainerPoint([arr.lat, arr.lng]);
    var newPoint = P.point([centerPoint.x + x, centerPoint.y + y]);
    var targetLatLng = this.map.containerPointToLatLng(newPoint);
    this.map.panTo(targetLatLng);

}
}
